import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import ContactForm from "../components/contact_form";
import Hero from "../components/hero";
import XLPOffers from "../components/xlp_offers";
import ProgramsAccordion from "../components/programs_accordion";

class XlpForSchools extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { isLoggedIn } = this.props;
    return (
      <>
        <div>
          <Header isLoggedIn={isLoggedIn} />

          <Hero
            // subtitle="Explore Interests, Develop Skills, Create Impact"
            title={
              <>
                Expertise for
                <br />
                lasting impact.
              </>
            }
            description="From strategy to execution, our tailored solutions help drive measurable impact at every stage of your school’s growth."
            buttonText="Explore Programs"
            buttonLink="#programs"
            imageSrc="assets-webp/misc/for-schools-hands-raised.webp"
            background="linear-gradient(to bottom, #f0f4f8 0%, #ffffff 100%)" // Overriding the default background
          />

          <XLPOffers
            title="Our Approach"
            description="Seamless Integration, Lasting Impact"
            imageSrc="assets-webp/flowcharts/approach-flowchart-schools.webp"
          />

          <ProgramsAccordion />

          <ContactForm />

          <Footer />
        </div>
      </>
    );
  }
}

export default XlpForSchools;
